import angularModule from 'ClientStorage/angularModule/scripts/client_storage_module';
import TransientClientStorage from '../../TransientClientStorage';

// Test mode gets a fresh in-memory store per injector, so specs do not share state. Everywhere
// else this is the TS TransientClientStorage that React code uses.
angularModule.factory('TransientClientStorage', [
    () => {
        //--------------------------
        // Test Mode
        //--------------------------

        if (window.RUNNING_IN_TEST_MODE) {
            const sessionStorage = {};
            sessionStorage.getItem = key => sessionStorage[key];

            sessionStorage.setItem = (key, value) => {
                value = String(value);
                sessionStorage[key] = value;
                return value;
            };
            sessionStorage.removeItem = key => {
                delete sessionStorage[key];
            };
            return sessionStorage;
        }

        return TransientClientStorage;
    },
]);
